import { render, staticRenderFns } from "./register.vue?vue&type=template&id=556c07b1&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/login.css?vue&type=style&index=0&id=556c07b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556c07b1",
  null
  
)

export default component.exports